import { useEffect, useRef, useState, type Dispatch, type SetStateAction, type default as React } from 'react';

import { Grid, Box } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { SearchButton, SelectCenter, SelectSupplier } from 'components/commonparts'

import type { GetMstCenterSupplierCenterSupplierGetRequest } from 'api-client'

interface SearchConditionProps {
  searchParam: GetMstCenterSupplierCenterSupplierGetRequest
  onSearch: (requestParam: GetMstCenterSupplierCenterSupplierGetRequest) => void
  hasDataEdited: boolean  // 編集中のデータがあるか？
  setDiscardChangeDialogOpen: Dispatch<SetStateAction<boolean>>,
  searchTrigger?: boolean // 親コンポーネントから検索実行された場合に値が変化する
}

function SearchCondition({
  searchParam, 
  onSearch, 
  hasDataEdited=false,
  setDiscardChangeDialogOpen,
  searchTrigger,
}: SearchConditionProps) {
  const { loginUserInfo } = useAuthContext()
  const [orgSupplierId, setOrgSupplierId] = useState(searchParam.orgSupplierId)
  const [centerId, setCenterId] = useState<number | null | undefined>(searchParam.centerId)
  const prevSearchTriggerRef = useRef<boolean | undefined>(undefined)

  // Sync state when searchParam changes
  useEffect(() => {
    setOrgSupplierId(searchParam.orgSupplierId)
    setCenterId(searchParam.centerId)
  }, [searchParam.orgSupplierId, searchParam.centerId])

  const onSearchClick=()=>{
    if (hasDataEdited) {
      setDiscardChangeDialogOpen((prev) => !prev)
      return
    }

    onSearch({
      companyId: loginUserInfo!.companyId,
      orgSupplierId,
      centerId,
      enabled: false,
    })      
  }

  useEffect(() => {
    // searchTriggerの変更を検知して、検索イベントを起こす
    // 親コンポーネントなどで検索を行いたい場合は、このトリガーを使用する
    // Only trigger if searchTrigger changed, not on initial mount
    if (searchTrigger !== undefined && prevSearchTriggerRef.current !== undefined && searchTrigger !== prevSearchTriggerRef.current) {
      onSearch({
        companyId: loginUserInfo!.companyId,
        orgSupplierId,
        centerId,
        enabled: false,
      })
    }
    prevSearchTriggerRef.current = searchTrigger
  }, [searchTrigger])

  return (
    <Grid container>
      <SelectCenter
              trCompanyId={searchParam.companyId}
              centerId={centerId}
              setCenterId={setCenterId}
              setCenterInfo={() => {}}
              isRequired={false}
              setIsValid={() => {}}
              enabled={false}
            />
      <SelectSupplier
        trCompanyId={searchParam.companyId}
        orgSupplierId={orgSupplierId}
        setOrgSupplierId={setOrgSupplierId}
        centerId={centerId}
        setSupplierInfo={() => {}}
        isRequred={false}
        setIsValid={() => {}}
        enabled={false}
        alignmentFlag
        />
      <Box display="flex" justifyContent="center" alignItems="end" marginBottom='5px' marginRight='10px'>
          <SearchButton searchId="item" onSearchClick={onSearchClick}/>
      </Box>
    </Grid>
  )
}

export default SearchCondition
